import * as React from 'react'
import isEmpty from 'lodash.isempty'
import Help from '../../../../../components/Help'
import { GenericInput } from '../../../../../components/Inputs'
import { templateStyles } from './templateStyles'

export const Form = ({ input, onFormPreviewChange, index }) => {
  const props = input.get('props')

  const propsJS = props.toJS()
  const { helpText, ...childComponentProps } = propsJS

  return (
    <div>
      <GenericInput
        className="bp3-fill"
        onChange={v => onFormPreviewChange(index, v)}
        title={props.get('label')}
        requiredLabelStyle={templateStyles.requiredLabel}
        {...childComponentProps}
        required={propsJS.required && isEmpty(propsJS.value)}
      />
      {props.get('helpText') && (
        <Help>
          <div>{props.get('helpText')}</div>
        </Help>
      )}
    </div>
  )
}

export const Configuration = ({ input, onChange }) => {
  const inputProps = input.get('props')
  return (
    <div>
      <GenericInput
        title="Placeholder"
        value={inputProps.get('placeholder')}
        onChange={v => onChange('placeholder', v)}
      />
    </div>
  )
}
